import { graphql } from "relay-runtime"
import { useBetterDocMutation } from "@/modules/admin/better-doc/hooks/useBetterDocMutation"
import { useSimulateBetterDocResearchMutation as useSimulateBetterDocResearchMutationType } from "@/modules/admin/better-doc/services/__generated__/useSimulateBetterDocResearchMutation.graphql"

const mutation = graphql`
  mutation useSimulateBetterDocResearchMutation($input: De_simulateBetterDocResearchInput!) {
    de_simulateBetterDocResearch(input: $input) {
      actionResult: de_BetterDocSessionActionResult {
        sessionId
        isSuccessful
        httpStatusCode
        betterDocState
        caseId
        errorReason
        exchangeId
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

export const useSimulateBetterDocResearchMutation = () => {
  return useBetterDocMutation<useSimulateBetterDocResearchMutationType>(mutation)
}
